export function getNextGroupId(groupOptions = []) {
  const ids = groupOptions
    .map((group) => Number(group?.id))
    .filter((id) => Number.isFinite(id) && id > 0);
  return ids.length ? Math.max(...ids) + 1 : 1;
}

export function addGroupOption(groupOptions = [], title) {
  const trimmedTitle = String(title || '').trim();
  if (!trimmedTitle) {
    return { ok: false, error: 'Group title cannot be empty' };
  }

  const normalized = trimmedTitle.toLowerCase();
  const exists = groupOptions.some(
    (group) => String(group?.title || '').trim().toLowerCase() === normalized
  );
  if (exists) {
    return { ok: false, error: 'Group title already exists' };
  }

  const newGroup = { id: getNextGroupId(groupOptions), title: trimmedTitle };
  return {
    ok: true,
    groupOptions: [...groupOptions, newGroup],
    newGroup,
  };
}

export function resolveGroupTitle(groupOptions = [], groupId, fallbackTitle = '') {
  const selected = groupOptions.find((group) => String(group?.id) === String(groupId));
  return selected?.title || fallbackTitle || '';
}

export function hasGroupAssignment(groupId, groupTitle = '') {
  return Boolean(String(groupId ?? '').trim() || String(groupTitle ?? '').trim());
}

export function getAssignedGroupLabel(groupOptions = [], groupId, groupTitle = '') {
  return String(resolveGroupTitle(groupOptions, groupId, groupTitle) || '').trim();
}
